import { Component, OnDestroy, OnInit } from '@angular/core';
import { Product } from '@shared/classes/product';
import { SlicePipe, CurrencyPipe } from '@angular/common';
import { ImageLoaderDirective } from '../../../../shared/directives/image-loader.directive';
import { RouterLink } from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-modal-cart',
    templateUrl: './modal-cart.component.html',
    styleUrls: ['./modal-cart.component.scss'],
    imports: [RouterLink, ImageLoaderDirective, SlicePipe, CurrencyPipe]
})
export class ModalCartComponent implements OnInit, OnDestroy {

  public products: Product[] = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    $('.addTocartModal').modal('hide');
  }

  relatedProducts(pro: Product) {
    return this.products.filter(function (products) {
      if (products.id !== pro.id) {
        return products.category === pro.category;
      }
    });
  }

}
